import { TablaActions, TablaTypes } from "../../consts/TablaTypes";

export const agregarArchivos = (payload : File[]) : TablaActions => ({
    type: TablaTypes.AGREGAR_ARCHIVOS,
    payload
});

export const eliminarArchivo = (payload : File) : TablaActions => ({
    type: TablaTypes.ELIMINAR_ARCHIVO,
    payload
})

export const limpiarAdjuntos = () : TablaActions => ({
    type: TablaTypes.LIMPIAR_ADJUNTOS
})